import { render, staticRenderFns } from "./max-editor.vue?vue&type=template&id=08d10313&scoped=true"
import script from "./max-editor.vue?vue&type=script&lang=js"
export * from "./max-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d10313",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d10313')) {
      api.createRecord('08d10313', component.options)
    } else {
      api.reload('08d10313', component.options)
    }
    module.hot.accept("./max-editor.vue?vue&type=template&id=08d10313&scoped=true", function () {
      api.rerender('08d10313', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/max-editor.vue"
export default component.exports